// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d556a501","326":"380f3144","455":"2b2caa5a","781":"c0f3f8e7","977":"8a695771"}[chunkId] + ".chunk.js";
};